import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { PublicComponent } from './components/layouts/public/public.component';
import { PrivateComponent } from './components/layouts/private/private.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { AccountInfoComponent } from './components/account-info/account-info.component';
import { LogoComponent } from './components/logo/logo.component';
import { HeaderActionsComponent } from './components/header-actions/header-actions.component';
import { StreamComponent } from './components/stream/stream.component';
import { SidebarAccountInfoComponent } from './components/sidebar/sidebar-account-info/sidebar-account-info.component';
import { SidebarMyLinksComponent } from './components/sidebar/sidebar-my-links/sidebar-my-links.component';
import { RegistrationFormComponent } from './components/registration-form/registration-form.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EventComponent } from './components/exams-calendar/event/event.component';
import { TextWithTooltipComponent } from './components/text-with-tooltip/text-with-tooltip.component';
import { TestBlocklistsComponent } from './components/Tests/test-blocklists/test-blocklists.component';
import { TestWhatupSliderComponent } from './components/Tests/test-whatup-slider/test-whatup-slider.component';
import { TestStudnetsQuestsComponent } from './components/Tests/test-studnets-quests/test-studnets-quests.component';
import { TestSpecializtionsComponent } from './components/Tests/test-specializtions/test-specializtions.component';
import { TestAdmissionChancesComponent } from './components/Tests/test-admission-chances/test-admission-chances.component';
import { TestParagraphComponent } from './components/Tests/test-paragraph/test-paragraph.component';
import { TestDepartmentCoursesComponent } from './components/Tests/test-department-courses/test-department-courses.component';
import { TestExplanaltoryCubesComponent } from './components/Tests/test-explanaltory-cubes/test-explanaltory-cubes.component';
import { TestGraduatsQuotesComponent } from './components/Tests/test-graduats-quotes/test-graduats-quotes.component';
import { TestBannerSectionComponent } from './components/Tests/test-banner-section/test-banner-section.component';
import { TestContactusDetailsComponent } from './components/Tests/test-contactus-details/test-contactus-details.component';
import { TestEmploymentsSectionComponent } from './components/Tests/test-employments-section/test-employments-section.component';
import { TestInterestedSectionComponent } from './components/Tests/test-interested-section/test-interested-section.component';
import { TestBuildingCareerComponent } from './components/Tests/test-building-career/test-building-career.component';
import { TestAllPossibleCombinationsComponent } from './components/Tests/test-all-possible-combinations/test-all-possible-combinations.component';
import { TestInfoIconsSectionComponent } from './components/Tests/test-info-icons-section/test-info-icons-section.component';
import { TestPopularCombinationsDegreeComponent } from './components/Tests/test-popular-combinations-degree/test-popular-combinations-degree.component';
import { TestGalleryImageRteComponent } from './components/Tests/test-gallery-image-rte/test-gallery-image-rte.component';
import { TestQuestionsAndAnswersComponent } from './components/Tests/test-questions-and-answers/test-questions-and-answers.component';
import { TestTextLinkDescriptionSectionComponent } from './components/Tests/test-text-link-description-section/test-text-link-description-section.component';
import { TestNumberAndFactsSectionComponent } from './components/Tests/test-number-and-facts-section/test-number-and-facts-section.component';
import { TestRecommendatniosSectionsComponent } from './components/Tests/test-recommendatnios-sections/test-recommendatnios-sections.component';
import { TestFacultiesRequirementsSectionComponent } from './components/Tests/test-faculties-requirements-section/test-faculties-requirements-section.component';
import { TestIconDescriptionsComponent } from './components/Tests/test-icon-descriptions/test-icon-descriptions.component';
import { TestSimpleTextDescriptionComponent } from './components/Tests/test-simple-text-description/test-simple-text-description.component';
import { TestOpenedCubesSliderComponent } from './components/Tests/test-opened-cubes-slider/test-opened-cubes-slider.component';
import { TestChessCubesSectionComponent } from './components/Tests/test-chess-cubes-section/test-chess-cubes-section.component';
import { TestTitleDescriptionButtonImageComponent } from './components/Tests/test-title-description-button-image/test-title-description-button-image.component';
import { TestResearchersComponent } from './components/Tests/test-researchers/test-researchers.component';
import { TestStudentTitleLinksComponent } from './components/Tests/test-student-title-links/test-student-title-links.component';
import { TestTitleDescriptionIconsComponent } from './components/Tests/test-title-description-icons/test-title-description-icons.component';
import { TestResearchSectionComponent } from './components/Tests/test-research-section/test-research-section.component';
import { TestTipsGallerySectionComponent } from './components/Tests/test-tips-gallery-section/test-tips-gallery-section.component';
import { TestAdmissionProcessTabsComponent } from './components/Tests/test-admission-process-tabs/test-admission-process-tabs.component';
import { TestSpotlightsComponent } from './components/Tests/test-spotlights/test-spotlights.component';
import { TestNewsSliderComponent } from './components/Tests/test-news-slider/test-news-slider.component';
import { TestExcellentProgramsComponent } from './components/Tests/test-excellent-programs/test-excellent-programs.component';
import { TestMoreInfoMediaComponent } from './components/Tests/test-more-info-media/test-more-info-media.component';
import { TestRichTextEcditorComponent } from './components/Tests/test-rich-text-ecditor/test-rich-text-ecditor.component';
import { SafeHtmlPipe } from '../shared/pipes/safe-html.pipe';
import { MatCardModule } from '@angular/material/card';
import { CardHeaderComponent } from './components/card-header/card-header.component';
import { EventDetailsComponent } from './components/exams-calendar/event-details/event-details.component';
import { RecentMessagesComponent } from './components/recent-messages/recent-messages.component';
import { AllMessagesComponent } from './components/all-messages/all-messages.component';
import { MessageComponent } from './components/all-messages/message/message.component';
import { RecentMessageComponent } from './components/recent-messages/recent-message/recent-message.component';
import { register } from 'swiper/element/bundle';
import { DepartmentInfoComponent } from './components/department-info/department-info.component';
import { CommonOperationsComponent } from './components/common-operations/common-operations.component';
import { DeanCardComponent } from './components/dean-card/dean-card.component';
import { AboutUsCardComponent } from './components/about-us-card/about-us-card.component';
import { WhatsGoingCardComponent } from './components/whats-going-card/whats-going-card.component';
import { AssistCardComponent } from './components/assist-card/assist-card.component';
import { CareerCardComponent } from './components/career-card/career-card.component';
import { ServicesCardComponent } from './components/services-card/services-card.component';
import { OfficersCardComponent } from './components/officers-card/officers-card.component';
import { VideoPreviewComponent } from './components/video-preview/video-preview.component';
import { AboutUsFeatureComponent } from './components/about-us-card/about-us-feature/about-us-feature.component';
import { EventCardComponent } from './components/whats-going-card/event-card/event-card.component';
import { CareerItemComponent } from './components/career-card/career-item/career-item.component';
import { PersonComponent } from './components/angularBlockList/portal-content-footer/person/person.component';
import { AlertComponent } from './components/alert/alert.component';
import { MatTableModule } from '@angular/material/table';
import { AllGradsFiltersComponent } from './components/all-grads-filters/all-grads-filters.component';
import { MatSelectModule } from '@angular/material/select';
import { ExamsCalendarComponent } from './components/exams-calendar/exams-calendar.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { UsefulLinksComponent } from './components/useful-links/useful-links.component';
import { ExamsListComponent } from './components/exams-list/exams-list.component';
import { ExamItemComponent } from './components/exams-list/exam-item/exam-item.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { DropdownTriggerDirective } from './components/dropdown/dropdown-trigger/dropdown-trigger.directive';
import { DropdownHostDirective } from './components/dropdown/dropdown-host/dropdown-host.directive';
import { DropdownContentComponent } from './components/dropdown/dropdown-Content/dropdown-content.component';
import { FilterItemComponent } from './components/filter-item/filter-item.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NotificationsModalComponent } from './components/modals/notifications-modal/notifications-modal.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HebrewDayNamePipe } from './pipes/hebrew-day-name.pipe';
import { ShareButtonComponent } from './components/share-button/share-button.component';
import { NotificationComponent } from './components/notification/notification.component';
import { CoursesListComponent } from './components/courses-list/courses-list.component';
import { CoursesFiltersComponent } from './components/courses-filters/courses-filters.component';
import { CourseItemComponent } from './components/course-item/course-item.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { SanitizedHtmlPipe } from './pipes/sanitized-html.pipe';
import { ScheduleComponent } from './components/schedule/schedule.component';
import { ScheduleNotRegisteredComponent } from './components/schedule-not-registered/schedule-not-registered.component';
import { ScheduleColComponent } from './components/schedule/schedule-col/schedule-col.component';
import { ScheduleSlotComponent } from './components/schedule/schedule-slot/schedule-slot.component';
import { ScheduleLessonComponent } from './components/schedule/schedule-lesson/schedule-lesson.component';
import { ScheduleFilterComponent } from './components/schedule/schedule-filter/schedule-filter.component';
import { PrintButtonComponent } from './components/print-button/print-button.component';
import { StudentGradesSummaryBlockListComponent } from './components/angularBlockList/student-grades-summary-block-list/student-grades-summary-block-list.component';
import { MyGradesComponent } from '../pages/grades-page/my-grades/my-grades.component';
import { StudentRecentInformationListViewBlockListComponent } from './components/angularBlockList/student-recent-information-list-view-block-list/student-recent-information-list-view-block-list.component';
import { StudentAllGradesDetailedListViewBlockListComponent } from './components/angularBlockList/student-all-grades-detailed-list-view-block-list/student-all-grades-detailed-list-view-block-list.component';
import { ExamsAndTasksCalendarBlockListComponent } from './components/angularBlockList/exams-and-tasks-calendar-block-list/exams-and-tasks-calendar-block-list.component';
import { StudentCoursesAndTimeTableCalendarBlockListComponent } from './components/angularBlockList/student-courses-and-time-table-calendar-block-list/student-courses-and-time-table-calendar-block-list.component';
import { AdditionalLinksBlockListComponent } from './components/angularBlockList/additional-links-block-list/additional-links-block-list.component';

import { PortalVideoWithDescriptionComponent } from './components/angularBlockList/portal-video-with-description/portal-video-with-description.component';
import { RecentlyAcceptedComponent } from '../pages/grades-page/recently-accepted/recently-accepted.component';
import { PortalPromotedInfoComponent } from './components/angularBlockList/portal-promoted-info/portal-promoted-info.component';
import { PortalPromotedFeatureComponent } from './components/angularBlockList/portal-promoted-info/portal-promoted-feature/portal-promoted-feature.component';
import { PortalEventComponent } from './components/angularBlockList/portal-event/portal-event.component';
import { PortalEventCard } from './components/angularBlockList/portal-event/portal-event-card/portal-event-card.component';
import { PortalButtonComponent } from './components/angularBlockList/shared/portal-button/portal-button.component';
import { PortalSupportInfo } from './components/angularBlockList/portal-support-info/portal-support-info.component';
import { PortalCareerPromotedItem } from './components/angularBlockList/portal-career-promoted-Content/portal-career-promoted-item/portal-career-promoted-item.component';
import { PortalCareerPromotedContent } from './components/angularBlockList/portal-career-promoted-Content/portal-career-promoted-content.component';
import { PortalOrganizationalServices } from './components/angularBlockList/portal-organizational-services/portal-organizational-services.component';
import { PortalContentFooter } from './components/angularBlockList/portal-content-footer/portal-content-footer.component';
import { EventBlock } from './components/angularBlockList/event-block/event-block.component';
import { MessageBlockComponent } from './components/angularBlockList/message-block/message-block.component';
import { MessagesComponent } from './components/angularBlockList/message-block/message/messages.component';
import { PortalLinksComponent } from './components/angularBlockList/portal-links/portal-links.component';
import { PortalQuestionsAndAnswersComponent } from './components/angularBlockList/portal-questions-and-answers/portal-questions-and-answers.component';
import { PotalCardHeaderComponent } from './components/angularBlockList/portal-video-with-description/portal-card-header/portal-card-header.component';
import { PortalCustomRowComponent } from './components/angularBlockList/shared/portal-custom-row/portal-custom-row.component';
import { SuccessStoriesCubesComponent } from './components/success-stories-cubes/success-stories-cubes.component';
import { CollaborationsComponent } from './components/collaborations/collaborations.component';

import { StudentExamsAndTasksListViewBlockListComponent } from './components/angularBlockList/exams-and-tasks-list-view-block-list/exams-and-tasks-list-view-block-list.component';
import { ExamsListCardComponent } from '../pages/exams-page/exams-list-card/exams-list-card.component';
import { SearchBlockComponent } from '../shared/components/search-block/search-block.component';

register();
import { CatalogComponent } from './components/catalog/catalog.component';
import { SearchFieldComponent } from './components/search-field/search-field.component';
import { CatalogCardComponent } from './components/catalog-card/catalog-card.component';
import { ExpansionPanelComponent } from './components/expansion-panel/expansion-panel.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { WidgetGridCardComponent } from './components/widget-grid-card/widget-grid-card.component';
import { WidgetStudentTaskCalendar } from './components/widget-student-task-calendar/widget-student-task-calendar';
import { WidgetStaffCalendar } from './components/widget-staff-calendar/widget-staff-calendar';
import { WidgetBookmarks } from './components/widget-bookmarks/widget-bookmarks';
import { BookmarksModal } from './components/widget-bookmarks/bookmarks-modal/bookmarks-modal';
import { MyDayComponent } from './components/widget-student-task-calendar/my-day/my-day.component';
import { MyMonthComponent } from './components/widget-student-task-calendar/my-month/my-month.component';
import { DayScheduleComponent } from './components/day-schedule/day-schedule.component';
import { ScheduleRangeComponent } from './components/schedule/schedule-range/schedule-range.component';
import { DayScheduleLessonComponent } from './components/day-schedule/day-schedule-lesson/day-schedule-lesson.component';
import { LessonDetailsComponent } from './components/day-schedule/lesson-details/lesson-details.component';
import { BillingTableComponent } from './components/angularBlockList/billing-table/billing-table.component';
import { GridCardComponent } from './components/home-cards-grid/grid-card/grid-card.component';
import { EventsCarouselComponent } from './components/events-carousel/events-carousel.component';
import { CloseEventItemComponent } from './components/widget-close-events-carousel/close-event-item/close-event-item.component';
import { WidgetCloseEventsCarouselComponent } from './components/widget-close-events-carousel/widget-close-events-carousel.component';
import { EventItemComponent } from './components/events-carousel/event-item/event-item.component';
import { EventShareButtonComponent } from './event-share-button/event-share-button.component';
import { WidgetNewsCarouselComponent } from './components/widget-news-carousel/widget-news-carousel.component';
import { NewsItemComponent } from './components/widget-news-carousel/news-item/news-item.component';
import { WidgetAccountStateComponent } from './components/widget-account-state/widget-account-state.component';
import { WidgetAssignmentsComponent } from './components/widget-assignments/widget-assignments.component';
import { MobileModalTriggerComponent } from './components/home-cards-grid/mobile-modal-trigger/mobile-modal-trigger.component';
import { DayOfWeekPipe } from './pipes/day-of-week/day-of-week.pipe';
import { WidgetMessagesComponent } from './components/widget-messages/widget-messages.component';
import { PreloaderComponent } from './components/preloader/preloader.component';
import { WidgetRequestsComponent } from './components/widget-requests/widget-requests.component';
import { WidgetRecentlyReceivedGradesComponent } from './components/widget-recently-received-grades/widget-recently-received-grades.component';
import { MonthEventsComponent } from './components/month-events/month-events.component';
import { MonthEventItemComponent } from './components/month-events/month-event-item/month-event-item.component';
import { LocationSelectPickerComponent } from './components/location-select-picker/location-select-picker.component';
import { WidgetSingleArticleComponent } from './components/widget-single-article/widget-single-article.component';
import { CustomDropdownComponent } from './components/custom-dropdown/custom-dropdown.component';
import { CareerLobbyPageComponent } from '../pages/career-lobby-page/career-lobby-page.component';
import { CareerLobbyPositionItemComponent } from '../pages/career-lobby-page/career-lobby-position-item/career-lobby-position-item.component';
import { CareerLobbyPositionsListComponent } from '../pages/career-lobby-page/career-lobby-positions-list/career-lobby-positions-list.component';
import { HebrewMonthPipe } from './pipes/hebrew-month/hebrew-month.pipe';
import { AllGradesComponent } from '../pages/grades-page/all-grades/all-grades.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { LessonNotificationsComponent } from './components/day-schedule/lesson-notifications/lesson-notifications.component';
import { EventLobbyItemComponent } from '../pages/events-lobby-page/event-lobby-item/event-lobby-item.component';
import { EventsLobbyComponent } from '../pages/events-lobby-page/events-lobby-page.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CustomDatepickerComponent } from './components/custom-datepicker/custom-datepicker.component';
import { MultiSelectComponent } from './components/multi-select/multi-select.component';
import { ExpansionDatePanelComponent } from './components/expansion-date-panel/expansion-date-panel.component';
import { ExpansionMobileMultiSelectPanelComponent } from './components/expansion-mobile-multi-select-panel/expansion-mobile-multi-select-panel.component';
import { SocialNetworksShareButtonComponent } from './components/social-networks-share-button/social-networks-share-button.component';
import { EventFormPopupComponent } from './components/event-form-popup/event-form-popup.component';
import { ArticlesAndNewsPageComponent } from '../pages/articles-and-news-page/articles-and-news-page.component';
import { CheckboxListComponent } from './components/custom-checkboxes/custom-checkboxes.component';
import { ArticlesAndNewsLobbyItemComponent } from '../pages/articles-and-news-page/articles-and-news-lobby-item/articles-and-news-lobby-item.component';
import { HighlightPipe } from './pipes/text-highlight.pipe';
import { SkeletonComponent } from '../loadingSkeletons/homepage-skeleton/skeleton.component';
import { ModifyMoodleLinksDirective } from './directives/modify-moodle-links.directive';
import { ModifyCookiesLinkDirective } from './directives/modify-cookies-links.directive';
import { CareerLatestJobsComponent } from './components/career-latest-jobs/career-latest-jobs.component';
import { ShortDayOfWeekPipe } from './pipes/short-day-of-week/short-day-of-week.pipe';
import { TimeoutErrorMessageComponent } from './components/timeout-error-message/timeout-error-message.component';
import { ModifyAnchorLinksDirective } from './directives/modify-anchor-links.directive';
import { PersonalizationPopup } from './components/personalization-popup/personalization-popup';
import { CustomSearchDropdownComponent } from './components/custom-search-dropdown/custom-search-dropdown.component';
@NgModule({
  declarations: [
    PublicComponent,
    PrivateComponent,
    HeaderComponent,
    SidebarComponent,
    AccountInfoComponent,
    LogoComponent,
    HeaderActionsComponent,
    StreamComponent,
    SidebarAccountInfoComponent,
    SidebarMyLinksComponent,
    RegistrationFormComponent,
    CardHeaderComponent,
    AlertComponent,
    AllGradsFiltersComponent,
    ExamsCalendarComponent,
    UsefulLinksComponent,
    ExamsListComponent,
    ExamItemComponent,
    DropdownComponent,
    DropdownTriggerDirective,
    DropdownHostDirective,
    DropdownContentComponent,
    FilterItemComponent,
    NotificationsModalComponent,
    HebrewDayNamePipe,
    ShareButtonComponent,
    NotificationComponent,
    SkeletonComponent,
    CoursesListComponent,
    EventDetailsComponent,
    RecentMessagesComponent,
    AllMessagesComponent,
    MessageComponent,
    RecentMessageComponent,
    BillingTableComponent,
    CommonOperationsComponent,
    DeanCardComponent,
    AboutUsCardComponent,
    WhatsGoingCardComponent,
    AssistCardComponent,
    CareerCardComponent,
    ServicesCardComponent,
    OfficersCardComponent,
    VideoPreviewComponent,
    AboutUsFeatureComponent,
    EventCardComponent,
    CareerItemComponent,
    PersonComponent,
    CoursesFiltersComponent,
    CourseItemComponent,
    SanitizedHtmlPipe,
    ScheduleComponent,
    ScheduleNotRegisteredComponent,
    ScheduleColComponent,
    ScheduleSlotComponent,
    ScheduleLessonComponent,
    ScheduleFilterComponent,
    PrintButtonComponent,
    EventComponent,
    TextWithTooltipComponent,
    TestBlocklistsComponent,
    TestWhatupSliderComponent,
    TestStudnetsQuestsComponent,
    TestSpecializtionsComponent,
    TestAdmissionChancesComponent,
    TestParagraphComponent,
    TestDepartmentCoursesComponent,
    TestExplanaltoryCubesComponent,
    TestGraduatsQuotesComponent,
    TestBannerSectionComponent,
    TestContactusDetailsComponent,
    TestEmploymentsSectionComponent,
    TestInterestedSectionComponent,
    TestBuildingCareerComponent,
    TestAllPossibleCombinationsComponent,
    TestInfoIconsSectionComponent,
    TestPopularCombinationsDegreeComponent,
    TestGalleryImageRteComponent,
    TestQuestionsAndAnswersComponent,
    TestTextLinkDescriptionSectionComponent,
    TestNumberAndFactsSectionComponent,
    TestRecommendatniosSectionsComponent,
    TestFacultiesRequirementsSectionComponent,
    TestIconDescriptionsComponent,
    TestSimpleTextDescriptionComponent,
    TestOpenedCubesSliderComponent,
    TestChessCubesSectionComponent,
    TestTitleDescriptionButtonImageComponent,
    TestResearchersComponent,
    TestStudentTitleLinksComponent,
    TestTitleDescriptionIconsComponent,
    TestResearchSectionComponent,
    TestTipsGallerySectionComponent,
    TestAdmissionProcessTabsComponent,
    TestSpotlightsComponent,
    TestNewsSliderComponent,
    TestExcellentProgramsComponent,
    TestMoreInfoMediaComponent,
    TestRichTextEcditorComponent,
    SafeHtmlPipe,
    MyGradesComponent,
    StudentGradesSummaryBlockListComponent,
    StudentRecentInformationListViewBlockListComponent,
    StudentAllGradesDetailedListViewBlockListComponent,
    ExamsAndTasksCalendarBlockListComponent,
    StudentCoursesAndTimeTableCalendarBlockListComponent,
    RecentlyAcceptedComponent,
    PortalVideoWithDescriptionComponent,
    PortalPromotedInfoComponent,
    PortalPromotedFeatureComponent,
    PortalEventComponent,
    PortalEventCard,
    PortalButtonComponent,
    PortalSupportInfo,
    PortalCareerPromotedItem,
    PortalCareerPromotedContent,
    PortalOrganizationalServices,
    PortalContentFooter,
    EventBlock,
    EventItemComponent,
    MessageBlockComponent,
    MessagesComponent,
    PortalLinksComponent,
    PortalQuestionsAndAnswersComponent,
    PotalCardHeaderComponent,
    PortalCustomRowComponent,
    DepartmentInfoComponent,
    CatalogCardComponent,
    SearchFieldComponent,
    ExpansionPanelComponent,
    CatalogComponent,
    ExamsListCardComponent,
    StudentExamsAndTasksListViewBlockListComponent,
    WidgetGridCardComponent,
    WidgetStudentTaskCalendar,
    WidgetStaffCalendar,
    WidgetBookmarks,
    BookmarksModal,
    MyDayComponent,
    MyMonthComponent,
    DayScheduleComponent,
    ScheduleRangeComponent,
    DayScheduleLessonComponent,
    LessonDetailsComponent,
    AdditionalLinksBlockListComponent,
    GridCardComponent,
    EventsCarouselComponent,
    CloseEventItemComponent,
    WidgetCloseEventsCarouselComponent,
    WidgetAccountStateComponent,
    EventShareButtonComponent,
    WidgetNewsCarouselComponent,
    NewsItemComponent,
    PreloaderComponent,
    WidgetAssignmentsComponent,
    MobileModalTriggerComponent,
    DayOfWeekPipe,
    ShortDayOfWeekPipe,
    WidgetMessagesComponent,
    WidgetRequestsComponent,
    CustomDropdownComponent,
    WidgetRecentlyReceivedGradesComponent,
    MonthEventsComponent,
    MonthEventItemComponent,
    LocationSelectPickerComponent,
    WidgetSingleArticleComponent,
    CareerLobbyPageComponent,
    CareerLobbyPositionItemComponent,
    CareerLobbyPositionsListComponent,
    HebrewMonthPipe,
    SearchBlockComponent,
    AllGradesComponent,
    PaginatorComponent,
    EventsLobbyComponent,
    EventLobbyItemComponent,
    CustomDatepickerComponent,
    MultiSelectComponent,
    ExpansionDatePanelComponent,
    ExpansionMobileMultiSelectPanelComponent,
    SocialNetworksShareButtonComponent,
    EventFormPopupComponent,
    LessonNotificationsComponent,
    ArticlesAndNewsPageComponent,
    CheckboxListComponent,
    ArticlesAndNewsLobbyItemComponent,
    HighlightPipe,
    ModifyMoodleLinksDirective,
    ModifyCookiesLinkDirective,
    ModifyAnchorLinksDirective,
    CareerLatestJobsComponent,
    TimeoutErrorMessageComponent,
    SuccessStoriesCubesComponent,
    CollaborationsComponent,
    PersonalizationPopup,
    CustomSearchDropdownComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    MatTableModule,
    MatSelectModule,
    MatRadioModule,
    MatDialogModule,
    MatTooltipModule,
    MatExpansionModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ],
  exports: [
    PublicComponent,
    PrivateComponent,
    HeaderComponent,
    SidebarComponent,
    RegistrationFormComponent,
    MatIconModule,
    MatCardModule,
    MatMenuModule,
    CardHeaderComponent,
    AlertComponent,
    MatTableModule,
    AllGradsFiltersComponent,
    ExamsCalendarComponent,
    UsefulLinksComponent,
    ExamsListComponent,
    MatButtonModule,
    DropdownComponent,
    DropdownTriggerDirective,
    FilterItemComponent,
    MatRadioModule,
    MatDialogModule,
    ShareButtonComponent,
    NotificationComponent,
    AllMessagesComponent,
    RecentMessagesComponent,
    DepartmentInfoComponent,
    BillingTableComponent,
    CommonOperationsComponent,
    DeanCardComponent,
    AboutUsCardComponent,
    WhatsGoingCardComponent,
    AssistCardComponent,
    CareerCardComponent,
    ServicesCardComponent,
    OfficersCardComponent,
    VideoPreviewComponent,
    CoursesListComponent,
    CoursesFiltersComponent,
    ScheduleComponent,
    ScheduleNotRegisteredComponent,
    MatTooltipModule,
    PrintButtonComponent,
    TestBlocklistsComponent,
    TestWhatupSliderComponent,
    TestStudnetsQuestsComponent,
    TestSpecializtionsComponent,
    TestAdmissionChancesComponent,
    TestParagraphComponent,
    TestDepartmentCoursesComponent,
    TestExplanaltoryCubesComponent,
    TestGraduatsQuotesComponent,
    TestBannerSectionComponent,
    TestContactusDetailsComponent,
    TestEmploymentsSectionComponent,
    TestInterestedSectionComponent,
    TestBuildingCareerComponent,
    TestAllPossibleCombinationsComponent,
    TestInfoIconsSectionComponent,
    TestPopularCombinationsDegreeComponent,
    TestGalleryImageRteComponent,
    TestQuestionsAndAnswersComponent,
    TestTextLinkDescriptionSectionComponent,
    TestNumberAndFactsSectionComponent,
    TestRecommendatniosSectionsComponent,
    TestFacultiesRequirementsSectionComponent,
    TestIconDescriptionsComponent,
    TestSimpleTextDescriptionComponent,
    TestOpenedCubesSliderComponent,
    TestChessCubesSectionComponent,
    TestTitleDescriptionButtonImageComponent,
    TestResearchersComponent,
    TestStudentTitleLinksComponent,
    TestTitleDescriptionIconsComponent,
    TestResearchSectionComponent,
    TestTipsGallerySectionComponent,
    TestAdmissionProcessTabsComponent,
    TestSpotlightsComponent,
    TestNewsSliderComponent,
    TestExcellentProgramsComponent,
    TestMoreInfoMediaComponent,
    TestRichTextEcditorComponent,
    SafeHtmlPipe,
    SkeletonComponent,
    MyGradesComponent,
    RecentlyAcceptedComponent,
    StudentGradesSummaryBlockListComponent,
    StudentRecentInformationListViewBlockListComponent,
    StudentAllGradesDetailedListViewBlockListComponent,
    ExamsAndTasksCalendarBlockListComponent,
    StudentCoursesAndTimeTableCalendarBlockListComponent,
    CatalogCardComponent,
    SearchFieldComponent,
    ExpansionPanelComponent,
    CatalogComponent,
    ExamsListCardComponent,
    AdditionalLinksBlockListComponent,
    StudentExamsAndTasksListViewBlockListComponent,
    WidgetGridCardComponent,
    WidgetStudentTaskCalendar,
    WidgetStaffCalendar,
    WidgetBookmarks,
    BookmarksModal,
    MyDayComponent,
    MyMonthComponent,
    DayScheduleComponent,
    ScheduleRangeComponent,
    DayScheduleLessonComponent,
    LessonDetailsComponent,
    GridCardComponent,
    EventsCarouselComponent,
    CloseEventItemComponent,
    WidgetCloseEventsCarouselComponent,
    WidgetAccountStateComponent,
    EventItemComponent,
    EventShareButtonComponent,
    WidgetNewsCarouselComponent,
    NewsItemComponent,
    WidgetAssignmentsComponent,
    MobileModalTriggerComponent,
    DayOfWeekPipe,
    ShortDayOfWeekPipe,
    WidgetMessagesComponent,
    WidgetRequestsComponent,
    WidgetRecentlyReceivedGradesComponent,
    PreloaderComponent,
    PortalLinksComponent,
    PortalQuestionsAndAnswersComponent,
    EventBlock,
    MessageBlockComponent,
    PortalContentFooter,
    PortalOrganizationalServices,
    PortalVideoWithDescriptionComponent,
    PortalPromotedInfoComponent,
    PortalEventComponent,
    PortalSupportInfo,
    PortalCareerPromotedContent,
    PortalCareerPromotedItem,
    MonthEventsComponent,
    MonthEventItemComponent,
    LocationSelectPickerComponent,
    WidgetSingleArticleComponent,
    CareerLobbyPageComponent,
    CareerLobbyPositionItemComponent,
    CareerLobbyPositionsListComponent,
    ScheduleSlotComponent,
    HebrewMonthPipe,
    SearchBlockComponent,
    AllGradesComponent,
    PaginatorComponent,
    LessonNotificationsComponent,
    EventsLobbyComponent,
    EventLobbyItemComponent,
    CustomDatepickerComponent,
    MultiSelectComponent,
    ExpansionDatePanelComponent,
    ExpansionMobileMultiSelectPanelComponent,
    SocialNetworksShareButtonComponent,
    EventFormPopupComponent,
    MatSlideToggleModule,
    ArticlesAndNewsPageComponent,
    CheckboxListComponent,
    ArticlesAndNewsLobbyItemComponent,
    CareerLatestJobsComponent,
    TimeoutErrorMessageComponent,
    SuccessStoriesCubesComponent,
    CollaborationsComponent,
    PersonalizationPopup,
    CustomSearchDropdownComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
